import Style from "./style";

export default function PageTitle({ children, text }) {
  return (
    <Style>
      <h3>{text}</h3>
      {children}
    </Style>
  );
}
